export const Slides = [
    
    { image:'../../assets/images/section2.jpg', 
      title:'澎湖縣藝術才能班學校',
      description:'美術班自民國七十四年成立，經由學有專長的教師參與輔導美育後，兒童們的創造力、欣賞力、與直觀的判斷力，不斷地提高，並有良好的學習成果。每次參加國內外學生美展，屢得金、銀、銅牌獎外，入選佳作更不勝其數，深獲長官暨社會人士所讚美與肯定。',
      linkText:'美術班招生簡章',
      link:'#'},
    { image:'../../assets/images/section1.jpg', 
      title:'培養STEAM跨領域素養和能力',
      description:'STEAM 5大精神包含：跨領域、動手做、生活應用、解決問題、五感學習。教育部在12年國民基本教育課程綱要總綱的「核心素養」中表示：素養指人在適應現在生活和面對未來挑戰時，所應具備的知識、能力和態度。與STEAM所倡導的學習精神符合。',
      linkText:'',
      link:''},
    { image:'../../assets/images/section3.jpg', 
      title:'行動載具融入教學',
      description:'我們希望學生充份運用科技的力量來輔助自身的學習與認知，讓學習變得有效、自學內化為能力，為此我們發展以「學習者為中心」的行動學習創新教學設計模式，與學生一同成長。',
      linkText:'澎湖縣中正國小行動學習社群',
      link:'https://plus.google.com/u/0/communities/105883601394755440333'},
  ];